export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14050.83822157.jpg";